import { render, staticRenderFns } from "./Verification.vue?vue&type=template&id=30a027e2&scoped=true"
import script from "./Verification.vue?vue&type=script&lang=ts"
export * from "./Verification.vue?vue&type=script&lang=ts"
import style0 from "./Verification.vue?vue&type=style&index=0&id=30a027e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a027e2",
  null
  
)

export default component.exports